import React from "react";
import { cn } from "../../../../../../utils/classnames";
import { useTranslation } from "react-i18next";

const DISCLAIMER_KEY = "editBooking.BookingReviewPage.disclaimer";

// One "For confirmed / pending bookings" block: a bold title and a bullet list.
const NoticeSection = ({ title, items }) => (
  <>
    <div className="tw:mb-[5px] tw:font-bold">{title}</div>
    <ul className="tw:list-disc tw:pl-5 tw:mb-[5px]">
      {items.map((item, index) => (
        <li key={index} className="tw:mb-[3px]"
          dangerouslySetInnerHTML={{ __html: item }}
        />
      ))}
    </ul>
  </>
);

// Deferred-payment business users are billed by monthly invoice, so their
// notes talk about the invoice instead of card authorization, charges and refunds.
const ImportantNotice = ({ getTypographyClass, deferredPayment = false }) => {
  const { t } = useTranslation();

  // Deferred users read their own bullet lists; section titles are shared.
  const contentKey = deferredPayment ? `${DISCLAIMER_KEY}.deferredPayment` : DISCLAIMER_KEY;

  // A translation list may come back as a single string; always render a list.
  const getList = (key) => {
    const value = t(key, { returnObjects: true });
    return Array.isArray(value) ? value : [value];
  };

  const forConfirmedBookingsList = getList(`${contentKey}.forConfirmedBookings.contents`);
  const forBookingsPendingConfirmationList = getList(`${contentKey}.forBookingsPendingConfirmation.contents`);

  return (
    <section className="tw:w-full tw:flex tw:flex-col tw:gap-4">
      <div className="tw:text-[#4e4e4e] tw:text-[16px] tw:font-bold">{t(`${DISCLAIMER_KEY}.title`)}</div>
      <div
        className={cn(
          "tw:w-[calc(100%+32px)] tw:-mx-4 tw:sm:mx-0 tw:sm:w-full tw:border tw:border-[#e8e8e8] tw:bg-white tw:sm:rounded-[5px] tw:p-5 tw:text-[#4e4e4e] tw:whitespace-pre-wrap tw:overflow-hidden",
          getTypographyClass(14)
        )}
      >
        <div className="tw:mb-[5px]"
          dangerouslySetInnerHTML={{ __html: t(`${DISCLAIMER_KEY}.content1`) }}
        />
        <div className="tw:mb-[5px]">&nbsp;</div>
        <NoticeSection
          title={t(`${DISCLAIMER_KEY}.forConfirmedBookings.title`)}
          items={forConfirmedBookingsList}
        />
        <div className="tw:mb-[5px]">&nbsp;</div>
        <NoticeSection
          title={t(`${DISCLAIMER_KEY}.forBookingsPendingConfirmation.title`)}
          items={forBookingsPendingConfirmationList}
        />
        {deferredPayment && (
          <>
            <div className="tw:mb-[5px]">&nbsp;</div>
            <div className="tw:italic">{t(`${DISCLAIMER_KEY}.deferredPayment.estimateNote`)}</div>
          </>
        )}
      </div>
    </section>
  )
};

export default ImportantNotice;
